<div class="join-dialog flex flex-row flex-start-stretch gap-60">
  <div class="join-dialog-image-content flex-initial hidden md:flex" data-test-id="join-dialog-image-content">
    <img alt="map" src="assets/images/newsletter/remote-work.svg" />
  </div>
  <div class="newsletter-dialog-content flex flex-col flex-full flex-start-between">
    <h4 data-test-id="newsletter-dialog-content-title" mat-dialog-title>
      You are out of the loop while cool stuff is happening
      <button
        (click)="closeDialog()"
        class="close-btn newsletter-dialog-content-button"
        data-test-id="newsletter-dialog-content-button"
        isIconButton="true"
        mat-button
      >
        <mat-icon svgIcon="close"></mat-icon>
      </button>
    </h4>
    <form
      [formGroup]="newsletterForm"
      (ngSubmit)="onSubmit()"
      class="flex flex-col w-full h-full flex-full"
      data-test-id="newsletter-dialog-content-form"
      name="newsletterForm"
      novalidate
    >
      <div class="flex flex-col flex-start-stretch gap-24" data-test-id="newsletter-dialog-content-text" mat-dialog-content>
        <p>
          Updates are paused due to your communication preferences. This means you may miss important events, development initiatives and key business news from 7N.
        </p>
        <p>
          You can change this at any time by updating your consent below. Read more about 7N’s processing of your personal data in 7N’s <a href="https://www.7N.com/privacy-policy/" target="_blank">Privacy Policy</a>.
        </p>
        <div>
          <mat-checkbox
            color="primary"
            data-test-id="user-profile-newsletter-checkbox"
            disableRipple="true"
            formControlName="AcceptMy7nNewsletter"
          >
            I want to receive 7N newsletters with news, events and service information.
          </mat-checkbox>
          <validation-messages
            [field]="newsletterForm.controls['AcceptMy7nNewsletter']"
            [messages]="['required']"
            [texts]="{ required: 'To confirm please select the checkbox' }"
          ></validation-messages>
        </div>
      </div>
      <div class="flex flex-end-center" mat-dialog-actions>
        <button
          [loading]="loading"
          class="small-button"
          color="primary"
          data-test-id="newsletter-dialog-content-form-send-button"
          mat-flat-button
          type="submit"
        >
          Confirm
        </button>
        <button
          (click)="closeDialog()"
          class="small-button"
          color="primary"
          data-test-id="newsletter-dialog-content-form-cancel-button"
          mat-button
          type="button"
        >
          Cancel
        </button>
      </div>
    </form>
  </div>
</div>
